import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { BRAND } from "../lib/brand";

export const Footer = () => {
  return (
    <footer className="relative overflow-hidden bg-[#212121] pt-20 text-white" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid gap-12 pb-16 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <div className="grid h-16 w-16 place-items-center rounded-2xl bg-white shadow-lg ring-1 ring-white/20">
                <img src={BRAND.logo} alt="Featherbomb" className="h-14 w-14 object-contain" />
              </div>
              <span className="font-display text-2xl uppercase tracking-tight">
                Feather<span className="text-[#EE4026]">bomb</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
              The premium feather kick toy built for endless rallies. Turn any patch of ground into a court.
            </p>
            <div className="mt-6 flex gap-3">
              {[Instagram].map((Icon, i) => (
                <a
                  key={i}
                  href="https://www.instagram.com/myfeatherbomb/"
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`footer-social-${i}`}
                  className="grid h-11 w-11 place-items-center rounded-full border border-white/15 text-white/70 transition hover:border-[#EE4026] hover:text-[#EE4026]"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-white/40">Explore</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/" className="text-white/70 transition hover:text-[#EE4026]">Home</Link></li>
              <li><Link to="/about" className="text-white/70 transition hover:text-[#EE4026]">About Us</Link></li>
              <li><Link to="/shop" className="text-white/70 transition hover:text-[#EE4026]">Shop</Link></li>
              <li><Link to="/community" className="text-white/70 transition hover:text-[#EE4026]">Community</Link></li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-white/40">Say hi</p>
            <ul className="mt-5 space-y-3 text-sm text-white/70">
              <li>hello@{BRAND.domain}</li>
              <li>{BRAND.domain}</li>
              <li>Made for players everywhere</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 py-6">
          <p className="text-center font-mono text-[11px] uppercase tracking-widest text-white/40">
            © {new Date().getFullYear()} Featherbomb. Gravity is optional.
          </p>
        </div>
      </div>

      <div className="pointer-events-none select-none overflow-hidden">
        <p className="font-display -mb-6 whitespace-nowrap text-center text-[19vw] leading-none text-white/[0.04]">
          FEATHERBOMB
        </p>
      </div>
    </footer>
  );
};
